module.exports = __webpack_public_path__ + "img/p3.e9cd195a.png";